import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=6a970694&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a970694')) {
      api.createRecord('6a970694', component.options)
    } else {
      api.reload('6a970694', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=6a970694&", function () {
      api.rerender('6a970694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zkBf8K3p8CQo/JS/comp/starrating.vue"
export default component.exports